// extracted by mini-css-extract-plugin
export default {"oauthListItem":"NmwdJ3yg1mQMJ3t9n2p0"};